import { Tab, Tabs } from "@nextui-org/react";
import React from "react";

/**
 * ContentInfo Component
 * Displays overview and guidance text for metric frameworks
 * Only renders sections that have content
 * @param {Object} props - Component props
 * @param {string} props.overviewText - Overview text content
 * @param {string} props.guidanceText - Guidance text content
 * @returns {JSX.Element} Overview and guidance sections
 */
const ContentInfo = ({ overviewText = "", guidanceText = "" }) => {
  return (
    <>
      {/* Overview Section */}
      {overviewText !== "" && (
        <div className="flex flex-col gap-1 text-sm my-2">
          <p className="flex font-medium">Overview</p>
          <p className="text-gray">{overviewText}</p>
        </div>
      )}
      
      {/* Guidance Section */}
      {guidanceText !== "" && (
        <div className="flex flex-col gap-1 text-sm my-2">
          <p className="flex font-medium">Guidance</p>
          <p className="text-gray">{guidanceText}</p>
        </div>
      )}
    </>
  );
};

/**
 * MetricFrameworkInfo Component
 * Displays framework-specific information for metrics including overview and guidance
 * Currently shows generic information (tabs implementation commented out for future use)
 * @param {Object} props - Component props
 * @param {Object} props.CollectionInfo - Metric collection information
 * @param {Array} props.orgFrameworkDetails - Organization framework details
 * @returns {JSX.Element} Framework information display
 */
const MetricFrameworkInfo = ({ CollectionInfo, orgFrameworkDetails }) => {
  return (
    <div>
      {/* 
        TODO: Implement framework tabs when needed
        This will show different overview and guidance based on selected framework
        
        <Tabs
          aria-label="Dynamic tabs"
          items={orgFrameworkDetails}
          variant="light"
        >
          <Tab key="generic" title="Generic">
            <ContentInfo
              overviewText={CollectionInfo?.attributes?.Overview?.Generic || ""}
              guidanceText={CollectionInfo?.attributes?.Guidance?.Generic || ""}
            />
          </Tab>
          {orgFrameworkDetails?.map((item) => (
            <Tab key={item.id} title={item.attributes?.Name}>
              <ContentInfo
                overviewText={
                  CollectionInfo?.attributes?.Overview?.[item.attributes?.Name] ||
                  ""
                }
                guidanceText={
                  CollectionInfo?.attributes?.Guidance?.[item.attributes?.Name] ||
                  ""
                }
              />
            </Tab>
          ))}
        </Tabs>
      */}
      
      {/* Currently showing generic information only */}
      <ContentInfo
        overviewText={CollectionInfo?.attributes?.Overview?.Generic || ""}
        guidanceText={CollectionInfo?.attributes?.Guidance?.Generic || ""}
      />
    </div>
  );
};

export default MetricFrameworkInfo;
